import { EventAttendee } from 'common/types'

export const goToBigMarkerEvent = (attendee: EventAttendee) => {
    const bigMarkerLink = document.createElement('a')
    bigMarkerLink.setAttribute('href', attendee.metaData?.bmConferenceUrl)
    bigMarkerLink.setAttribute('target', '_blank')
    bigMarkerLink.click()
}